const userHasEntitlement = (entitlements, entitlement) =>
    entitlements.some(e => e.permission.toLowerCase().trim() === entitlement.toLowerCase().trim());

export default userHasEntitlement;
